import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const DualLaser = () => {
  const points = ['Le laser picoseconde génère des impulsions ultra-courtes, idéales pour fragmenter les encres résistantes', 'Le laser Q-Switched est très efficace pour les pigments noirs et foncés plus profonds', "La combinaison des deux permet d'adapter précisément chaque séance"];
  return;
};